// extracted by mini-css-extract-plugin
export default {"item":"user-view_item__ojkUp"};